var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgClaimEcoColor = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 21,
  viewBox: "0 0 21 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.192.286A.46.46 0 0 0 19.767 0C1.931 0 0 7.439 0 10.637c0 4.15 3.14 6.938 7.815 6.938 5.904 0 7.14-5.652 7.804-8.689A15.688 15.688 0 0 1 20.092.79a.464.464 0 0 0 .1-.503Z",
  fill: "#2DB875"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M.46 20.35a.461.461 0 0 1-.46-.462c0-2.75 4.74-11.574 12.212-15.216a.459.459 0 0 1 .614.214c.11.23.015.507-.213.618C5.067 9.184.918 17.726.918 19.888a.461.461 0 0 1-.46.462Z",
  fill: "#3CD58B"
})));
export default SvgClaimEcoColor;